"use strict";

($dt => {
	
	$dt.TopicGrid.Functions = {
		...$dt.TopicGrid.Functions,
		
		/**
		 * @param {Block} block 
		 * @param {*} on_complete 
		 */
		GetDateTimes: (block, on_complete) => {
			const { scheduling_info, current_topic } = block;
			const xhr = new XMLHttpRequest();
			xhr.open('POST', $dt.ajax_url);
			xhr.withCredentials = true;
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.onload = () => {
				if (xhr.status === 200) {
					const resp = JSON.parse(xhr.responseText);
					on_complete(resp);
				}
			};
			xhr.send(`action=dcube_edupgrams_gettimes&num_attendees=${scheduling_info.reservation_attendees}&topic_id=${current_topic.id}&date=${scheduling_info.selected_date}`);
		},
	};

})(window.d3_wp_themejs);
